export default function PartnersSection() {
  const partners = [
    {
      name: 'Rixin Corp',
      role: 'Fabricante Oficial — China',
      website: 'https://rixingroup.cn/',
      logo: 'https://rixingroup.cn/wp-content/uploads/2023/04/%E8%8B%B1%E6%96%87logo%E6%97%A0%E7%BD%91%E7%AB%99%E9%80%8F%E6%98%8E.png',
    },
    {
      name: 'Poly Alphas Chemicals C.A.',
      role: 'Asesoría Técnica — Venezuela',
      website: 'https://www.polyalphas.net/',
      logo: 'https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/dcc337184ae4c1c13653d5bd8b578418.png',
    },
  ];

  return (
    <section className="bg-background-100 py-16 md:py-24 border-t border-background-200/60">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-shake-hands-line text-sm w-4 h-4 flex items-center justify-center" />
              Aliados Estratégicos
            </div>
            <h2 className="font-heading text-xl sm:text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              Respaldados por{' '}
              <span className="text-primary-500">Líderes de la Industria</span>
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
              RESINVENCA colabora directamente con fabricantes y asesores de primera línea
              para garantizar calidad, respaldo técnico y resultados comprobados.
            </p>
          </div>

          {/* Partner Cards */}
          <div className="grid grid-cols-1 xs:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto">
            {partners.map((partner) => (
              <a
                key={partner.name}
                href={partner.website}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="group relative flex flex-col items-center text-center p-6 md:p-8 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-300/60 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 cursor-pointer"
              >
                {/* Logo */}
                <div className="w-full h-28 md:h-32 flex items-center justify-center mb-5">
                  <img
                    src={partner.logo}
                    alt={`Logo de ${partner.name}`}
                    className="max-w-full max-h-full object-contain"
                    loading="lazy"
                  />
                </div>

                {/* Name */}
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-1">
                  {partner.name}
                </h3>

                {/* Role */}
                <p className="text-foreground-500 text-xs md:text-sm mb-4">
                  {partner.role}
                </p>

                {/* Link */}
                <div className="inline-flex items-center gap-1.5 text-primary-500 text-sm font-medium group-hover:text-primary-600 transition-colors">
                  <span className="whitespace-nowrap">Visitar Sitio Web</span>
                  <i className="ri-external-link-line w-4 h-4 flex items-center justify-center group-hover:translate-x-0.5 transition-transform" />
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}